/* babbooll landing — galerij, varianten, bundel, Ajax-cart, sticky koopbalk */
(function () {
  'use strict';

  var money = function (cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  };

  /* ---------- Galerij ---------- */
  function initGalerijVideo(root) {
    // video die al een bron heeft: meteen proberen te starten
    var direct = root.querySelector('.blp-slide--video video[src]');
    if (direct) {
      direct.muted = true;
      var dp = direct.play();
      if (dp && dp.catch) dp.catch(function () {
        // browser weigerde; bij de eerste aanraking alsnog starten
        var start = function () { direct.play().catch(function(){}); document.removeEventListener('touchstart', start); document.removeEventListener('click', start); };
        document.addEventListener('touchstart', start, { once:true, passive:true });
        document.addEventListener('click', start, { once:true });
      });
    }

    var v = root.querySelector('[data-blp-galerijbron]');
    if (!v) return;
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) { if (!v.paused) v.pause(); return; }
        var bron = v.getAttribute('data-blp-galerijbron');
        if (bron && !v.src) {
          v.src = bron;
          v.removeAttribute('data-blp-galerijbron');
          v.load();
        }
        v.muted = true;
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      });
    }, { threshold: 0.2, rootMargin: '150px' });
    obs.observe(v.closest('.blp-offer-main') || v);
  }

  function initGallery(root) {
    var videoSlide = root.querySelector('[data-blp-videoslide]');
    var fotoSlide  = root.querySelector('[data-blp-fotoslide]');
    var hoofdFoto  = root.querySelector('[data-blp-main]');
    var thumbs     = root.querySelectorAll('[data-blp-kies]');
    if (!thumbs.length) return;

    function markeer(actief) {
      thumbs.forEach(function (t) { t.classList.toggle('is-active', t === actief); });
    }

    function toonVideo(actief) {
      if (!videoSlide) return;
      videoSlide.classList.add('is-active');
      if (fotoSlide) fotoSlide.classList.remove('is-active');
      var v = videoSlide.querySelector('video');
      if (v) { v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      markeer(actief);
    }

    function toonFoto(url, actief) {
      if (fotoSlide) fotoSlide.classList.add('is-active');
      if (videoSlide) {
        videoSlide.classList.remove('is-active');
        var v = videoSlide.querySelector('video');
        if (v && !v.paused) v.pause();
      }
      if (hoofdFoto && url) hoofdFoto.src = url;
      markeer(actief);
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        if (t.getAttribute('data-blp-kies') === 'video') toonVideo(t);
        else toonFoto(t.getAttribute('data-blp-bron'), t);
      });
      // bij hover alvast ophalen zodat het wisselen direct oogt
      t.addEventListener('mouseenter', function () {
        var b = t.getAttribute('data-blp-bron');
        if (b && !t.__voorgeladen) { t.__voorgeladen = true; new Image().src = b; }
      }, { passive: true });
    });

    // door de variantkeuze aan te roepen
    root.__blpToonMedia = function (url) {
      if (!url) return false;
      // urls verschillen alleen in de width-parameter; vergelijk op het pad
      var pad = url.split('?')[0];
      var match = null;
      thumbs.forEach(function (t) {
        var b = t.getAttribute('data-blp-bron');
        if (b && b.split('?')[0] === pad) match = t;
      });
      toonFoto(match ? match.getAttribute('data-blp-bron') : url, match);
      return true;
    };
  }

  /* ---------- Varianten ---------- */
  function initVariants(root) {
    var pills = root.querySelectorAll('[data-blp-variant]');
    if (!pills.length) return;
    var singleRow = root.querySelector('[data-blp-option="single"]');

    var peekEl = root.querySelector('[data-blp-peek]');
    var peekBtn = peekEl && peekEl.querySelector('[data-blp-peek-groot]');
    if (peekBtn) {
      peekBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        var actief = root.querySelector('[data-blp-variant].is-active');
        var url = actief && actief.getAttribute('data-blp-variant-image');
        if (url && typeof root.__blpToonMedia === 'function') {
          root.__blpToonMedia(url);
          var gal = root.querySelector('.blp-offer-gal-card');
          if (gal) gal.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    }

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        if (pill.hasAttribute('disabled')) return;
        pills.forEach(function (x) { x.classList.remove('is-active'); });
        pill.classList.add('is-active');

        var vid = parseInt(pill.getAttribute('data-blp-variant'), 10);

        // werk elke bundelregel bij: eerste item is altijd het hoofdproduct
        root.querySelectorAll('[data-blp-items]').forEach(function (row) {
          try {
            var items = JSON.parse(row.getAttribute('data-blp-items'));
            if (items.length) { items[0].id = vid; }
            row.setAttribute('data-blp-items', JSON.stringify(items));
          } catch (e) { /* stil */ }
        });

        var priceEl = singleRow && singleRow.querySelector('.blp-bundle-price');
        var priceTxt = pill.getAttribute('data-blp-price');
        if (priceEl && priceTxt) priceEl.textContent = priceTxt;

        var vImg = pill.getAttribute('data-blp-variant-image');

        // hoofdbeeld meeschakelen met het gekozen vriendje
        if (vImg && typeof root.__blpToonMedia === 'function') {
          root.__blpToonMedia(vImg);
        }

        // klein voorbeeldje onder de keuze
        var peek = root.querySelector('[data-blp-peek]');
        if (peek) {
          if (vImg) {
            var pi = peek.querySelector('[data-blp-peek-img]');
            var pn = peek.querySelector('[data-blp-peek-naam]');
            if (pi) { pi.src = vImg; pi.alt = pill.textContent.trim(); }
            if (pn) pn.textContent = pill.textContent.trim();
            peek.hidden = false;
          } else {
            peek.hidden = true;
          }
        }
      });
    });
  }

  function initPeekStart(root) {
    var actief = root.querySelector('[data-blp-variant].is-active');
    if (!actief) return;
    var peek = root.querySelector('[data-blp-peek]');
    var url = actief.getAttribute('data-blp-variant-image');
    if (!peek || !url) return;
    var pi = peek.querySelector('[data-blp-peek-img]');
    var pn = peek.querySelector('[data-blp-peek-naam]');
    if (pi) { pi.src = url; pi.alt = actief.textContent.trim(); }
    if (pn) pn.textContent = actief.textContent.trim();
    peek.hidden = false;
  }

  /* ---------- Bundelselector ---------- */
  function initBundle(root) {
    var rows = root.querySelectorAll('[data-blp-option]');
    if (!rows.length) return;

    function panelVoor(row) {
      var key = row.getAttribute('data-blp-detail');
      return key ? root.querySelector('[data-blp-detail-panel="' + key + '"]') : null;
    }

    function toon(row, open) {
      var panel = panelVoor(row);
      if (!panel) return;
      panel.hidden = !open;
      row.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    rows.forEach(function (row) {
      row.addEventListener('click', function () {
        var wasActief = row.classList.contains('is-active');

        rows.forEach(function (x) {
          x.classList.remove('is-active');
          toon(x, false);
        });
        row.classList.add('is-active');

        // uitklap: opent bij selecteren, klapt dicht bij nogmaals klikken
        var panel = panelVoor(row);
        if (panel) toon(row, !wasActief || panel.hidden);
      });

      // regel die bij het laden al actief is en een uitklap heeft, meteen openen
      if (row.classList.contains('is-active')) toon(row, true);
    });
  }

  /* ---------- Drawer verversen + openen (Horizon) ---------- */
  // Horizon rendert de drawer bij pagina-load. Openen alleen is niet genoeg:
  // de inhoud moet vervangen worden door de verse sectie-HTML uit /cart/add.js,
  // anders blijft "cart is empty" staan. Live geverifieerd op dit thema.
  function renderCartDrawer(sections) {
    if (!sections) return;

    var drawerHtml = sections['cart-drawer-section'];
    if (drawerHtml) {
      try {
        var doc = new DOMParser().parseFromString(drawerHtml, 'text/html');
        var nieuw = doc.querySelector('.cart-drawer__inner');
        var huidig = document.querySelector('.cart-drawer__inner');
        if (nieuw && huidig) {
          huidig.innerHTML = nieuw.innerHTML;
          huidig.className = nieuw.className; // haalt o.a. cart-drawer--empty weg
        }
      } catch (e) { /* stil */ }
    }

    var bubbleHtml = sections['cart-icon-bubble'];
    if (bubbleHtml) {
      try {
        var bdoc = new DOMParser().parseFromString(bubbleHtml, 'text/html');
        var nb = bdoc.querySelector('.cart-bubble') || bdoc.body.firstElementChild;
        var cb = document.querySelector('.cart-bubble');
        if (nb && cb) cb.replaceWith(nb);
      } catch (e) { /* stil */ }
    }
  }

  function openCartDrawer(sections) {
    renderCartDrawer(sections);

    var comp = document.querySelector('cart-drawer-component');
    var host = comp && comp.closest ? comp.closest('theme-drawer') : null;
    if (host && typeof host.open === 'function') {
      if (!host.hasAttribute('open')) {
        try { host.open(); return; } catch (e) { /* door naar fallback */ }
      } else {
        return; // stond al open, inhoud is ververst
      }
    }

    // Fallback voor themes zonder <theme-drawer>
    var opener = document.querySelector('.header-actions__cart-icon, a[href$="/cart"]');
    if (opener && opener.click) opener.click();
  }

  /* ---------- Ajax add-to-cart ---------- */
  function initAtc(root) {
    var btn = root.querySelector('[data-blp-atc]');
    if (!btn) return;

    var elDefault = btn.querySelector('[data-blp-cta-default]');
    var elLoading = btn.querySelector('[data-blp-cta-loading]');
    var elSuccess = btn.querySelector('[data-blp-cta-success]');
    var elError = root.querySelector('[data-blp-error]');

    function state(which) {
      [elDefault, elLoading, elSuccess].forEach(function (el) {
        if (el) el.hidden = true;
      });
      var map = { default: elDefault, loading: elLoading, success: elSuccess };
      if (map[which]) map[which].hidden = false;
    }

    btn.addEventListener('click', function () {
      var active = root.querySelector('[data-blp-option].is-active') ||
                   root.querySelector('[data-blp-option]');
      if (!active) return;

      var items;
      try { items = JSON.parse(active.getAttribute('data-blp-items')); }
      catch (e) { return; }
      if (!items || !items.length) return;

      if (elError) { elError.hidden = true; elError.textContent = ''; }
      state('loading');
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: items,
          sections: 'cart-drawer-section,cart-icon-bubble'
        })
      })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart');
            return data;
          });
        })
        .then(function (data) {
          state('success');
          openCartDrawer(data.sections);
          setTimeout(function () { state('default'); btn.disabled = false; }, 2200);
        })
        .catch(function (err) {
          state('default');
          btn.disabled = false;
          if (elError) {
            elError.textContent = err.message || 'Er ging iets mis. Probeer opnieuw.';
            elError.hidden = false;
          }
        });
    });
  }

  /* ---------- Sticky koopbalk op mobiel (RESPONSIVE.md) ---------- */
  function initStickyBar(root) {
    var cta = root.querySelector('[data-blp-atc]');
    if (!cta) return;
    if (document.querySelector('.blp-stickybar')) return;

    var titleEl = root.querySelector('.blp-h2');
    var priceEl = root.querySelector('[data-blp-option].is-active .blp-bundle-price') ||
                  root.querySelector('.blp-bundle-price');

    var bar = document.createElement('div');
    bar.className = 'blp blp-stickybar';
    bar.innerHTML =
      '<div class="blp-stickybar-inner">' +
        '<div class="blp-stickybar-text">' +
          '<span class="blp-stickybar-title"></span>' +
          '<span class="blp-stickybar-price"></span>' +
        '</div>' +
        '<button type="button" class="blp-stickybar-btn">Add to cart</button>' +
      '</div>';
    document.body.appendChild(bar);

    bar.querySelector('.blp-stickybar-title').textContent = titleEl ? titleEl.textContent.trim() : '';
    function syncPrice() {
      var p = root.querySelector('[data-blp-option].is-active .blp-bundle-price') || priceEl;
      bar.querySelector('.blp-stickybar-price').textContent = p ? p.textContent.trim() : '';
    }
    syncPrice();
    root.addEventListener('click', function () { setTimeout(syncPrice, 20); });

    bar.querySelector('.blp-stickybar-btn').addEventListener('click', function () {
      cta.click();
    });

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        bar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    obs.observe(cta);
  }

  /* ---------- Smooth scroll ---------- */
  function initSmoothScroll() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('.blp a[href^="#"]');
      if (!a) return;
      var id = a.getAttribute('href');
      if (!id || id === '#') return;
      var target = document.querySelector(id);
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  /* ---------- Videoband: alleen de tegels die echt in beeld staan spelen ---------- */
  function initMarquee() {
    var banden = document.querySelectorAll('[data-blp-marquee]');
    if (!banden.length) return;

    banden.forEach(function (band) {
      var videos = band.querySelectorAll('video');
      if (!videos.length) return;

      videos.forEach(function (v) {
        v.muted = true;
        v.setAttribute('muted', '');
        v.playsInline = true;
      });

      // 1) bron pas laden zodra de band nadert
      var bandObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) {
            videos.forEach(function (v) { if (!v.paused) v.pause(); });
            band.classList.remove('is-live');
          } else {
            band.classList.add('is-live');
          }
        });
      }, { threshold: 0, rootMargin: '300px' });
      bandObs.observe(band);

      // 2) per tegel: alleen spelen wat daadwerkelijk zichtbaar is
      var tegelObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var v = e.target.querySelector('video');
          if (!v) return;
          if (e.isIntersecting) {
            var lazy = v.getAttribute('data-blp-lazysrc');
            if (lazy && !v.src) {
              v.src = lazy;
              v.removeAttribute('data-blp-lazysrc');
              v.load();
            }
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          } else if (!v.paused) {
            v.pause();
          }
        });
      }, { threshold: 0.15 });

      band.querySelectorAll('.blp-mq-tile').forEach(function (t) { tegelObs.observe(t); });
    });
  }

  /* ---------- Aflopende teller ---------- */
  function initSale() {
    var secties = document.querySelectorAll('[data-blp-sale]');
    if (!secties.length) return;

    secties.forEach(function (sec) {
      var ruw = (sec.getAttribute('data-blp-einde') || '').trim();
      if (!ruw) return;
      // "2026-09-06 23:59" -> ISO, zodat Safari het ook slikt
      var eind = new Date(ruw.replace(' ', 'T') + (ruw.length <= 16 ? ':00' : ''));
      if (isNaN(eind.getTime())) return;

      var klok = sec.querySelector('[data-blp-klok]');
      var voorbij = sec.querySelector('[data-blp-voorbij]');
      var inner = sec.querySelector('.blp-sale-inner');
      var d = sec.querySelector('[data-blp-d]'), u = sec.querySelector('[data-blp-u]');
      var m = sec.querySelector('[data-blp-m]'), sc = sec.querySelector('[data-blp-s]');

      function pad(n) { return n < 10 ? '0' + n : String(n); }

      function tik() {
        var over = eind.getTime() - Date.now();
        if (over <= 0) {
          if (inner) inner.hidden = true;
          if (voorbij) voorbij.hidden = false;
          clearInterval(id);
          return;
        }
        var dg = Math.floor(over / 86400000);
        var ur = Math.floor(over / 3600000) % 24;
        var mn = Math.floor(over / 60000) % 60;
        var se = Math.floor(over / 1000) % 60;
        if (d) d.textContent = pad(dg);
        if (u) u.textContent = pad(ur);
        if (m) m.textContent = pad(mn);
        if (sc) sc.textContent = pad(se);
      }

      tik();
      var id = setInterval(tik, 1000);

      // niet doortikken als de sectie buiten beeld is
      if ('IntersectionObserver' in window) {
        var obs = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { tik(); if (!id) id = setInterval(tik, 1000); }
            else { clearInterval(id); id = null; }
          });
        }, { threshold: 0 });
        obs.observe(sec);
      }
    });
  }

  function boot() {
    document.querySelectorAll('.blp-offer').forEach(function (root) {
      initGallery(root);
      initGalerijVideo(root);
      initVariants(root);
      initPeekStart(root);
      initBundle(root);
      initAtc(root);
      initStickyBar(root);
    });
    initSmoothScroll();
    initMarquee();
    initSale();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();


/* ── Variantkeuze binnen een bundel ───────────────────────────────────────
   Een bundel legde altijd de EERSTE variant van het bijproduct in de wagen, dus
   wie sokjes in beige wilde kreeg roodbruin. De keuzemenu's in het uitklappaneel
   schrijven hun keuze terug in data-blp-items van de knop erboven, want dat is
   wat de add-to-cart leest. */
(function () {
  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('[data-blp-bundel-var]');
    if (!sel) return;
    var wrap = sel.closest('.blp-bundle-wrap');
    var knop = wrap && wrap.querySelector('[data-blp-items]');
    if (!knop) return;

    var items;
    try { items = JSON.parse(knop.getAttribute('data-blp-items')); } catch (err) { return; }
    var i = Number(sel.getAttribute('data-blp-bundel-var'));
    if (!items[i]) return;
    items[i].id = Number(sel.value);
    knop.setAttribute('data-blp-items', JSON.stringify(items));
  });

  /* Klikken in het paneel mag de kaart niet dichtklappen of opnieuw kiezen. */
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.blp-bd-kies')) e.stopPropagation();
  }, true);
})();
